export default [
  {
    path: "/kemahasiswaan/mahasiswa",
    name: "kemahasiswaan-mahasiswa",
    component: () =>
      import("../../views/rektorat/kemahasiswaan/mahasiswa/ListMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kemahasiswaan", url: "/submenu/kemahasiswaan" },
        { title: "Mahasiswa", active: true },
      ],
      pageTitle: "Mahasiswa",
    },
  },
  {
    path: "/kemahasiswaan/nilai-mahasiswa/:userId",
    name: "kemahasiswaan-nilai-mahasiswa",
    component: () =>
      import("../../views/rektorat/kemahasiswaan/mahasiswa/NilaiMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kemahasiswaan", url: "/submenu/kemahasiswaan" },
        { title: "Mahasiswa", url: "/akademik/mahasiswa" },
        {
          title: "Nilai Mahasiswa",
          active: true,
        },
      ],
      pageTitle: "Nilai Mahasiswa",
    },
  },

  {
    path: "/kemahasiswaan/detail-mahasiswa/:userId",
    name: "kemahasiswaan-detail-mahasiswa",
    component: () =>
      import(
        "../../views/rektorat/kemahasiswaan/mahasiswa/DetailMahasiswa.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kemahasiswaan", url: "/submenu/akademik" },
        { title: "Mahasiswa", url: "/kemahasiswaan/mahasiswa" },
        { title: "Detail mahasiswa", active: true },
      ],
      pageTitle: "Detail mahasiswa",
    },
  },
  {
    path: "/kemahasiswaan/krs-mahasiswa/:mahasiswaId",
    name: "kemahasiswaan-krs-mahasiswa",
    component: () =>
      import("../../views/rektorat/kemahasiswaan/mahasiswa/KrsMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kemahasiswaan", url: "/submenu/kemahasiswaan" },
        { title: "Mahasiswa", url: "/kemahasiswaan/mahasiswa" },
        { title: "KRS mahasiswa", active: true },
      ],
      pageTitle: "KRS mahasiswa",
    },
  },
];
